import { all, call, put, takeEvery, take } from 'redux-saga/effects'
import { t } from 'ttag'
import { getWhoAmI, getWhoAmIFail, getWhoAmISuccess } from '../../../common/auth/authActions'
import { addNotification, clearNotification } from '../../../common/notifications/NotificationActions'
import { INotification } from '../../../common/notifications/NotificationReducers'
import { currentLangString, saveLocale } from '../../../i18nInit'
import api from '../../../services/api.services'
import { doLogin } from './LoginActions'
import { isNative } from '../../../common/helpers/isNative'
import { reLocate } from '../../../common/Routes/RouterActions'
import { dataSync } from '../../../services/DataSync'
import { getErrorMsg } from '../../../common/helpers/translations'

function* sagaPasswordAuth({ payload }: any) {
  try {
    yield put({ type: String(clearNotification) })
    const { email, password } = payload
    const { lang /*, sessionId: sessionToken*/ } = yield call(api.auth.login, { email, password })

    //if (isNative()) {
    //const sessionToken = window.btoa(sessionId)
    //console.log(`Got sessionId (${sessionId}) and saving sessionToken (${sessionToken})`)
    //yield Preferences.set({ key: 'sessionToken', value: sessionToken })
    //}

    // Ensure that you're logged in now.
    yield put({ type: String(getWhoAmI) })

    // Just wait for getWhoAmI to finish. No need for extra call.
    yield take([String(getWhoAmISuccess), String(getWhoAmIFail)])

    saveLocale(currentLangString)

    if (String(lang) !== currentLangString) {
      if (isNative()) {
        window.location.reload()
      } else {
        // Refresh the page and remove lang query parameter (if present).
        window.location.href = window.location.href.split('?')[0]
      }
    }

    yield put({ type: String(reLocate) })

    // Make sure Apple Health is synced on login.
    if (isNative()) {
      setTimeout(() => {
        dataSync(true).then()
      }, 1000)
    }
  } catch (e: any) {
    if (e.status === 401 || e.status === 403) {
      const loginErrorNotification: INotification = {
        type: 'warning',
        content: t`Your email or password is incorrect`,
      }
      yield put({ type: String(addNotification), payload: loginErrorNotification })
    } else {
      const loginErrorNotification: INotification = {
        type: 'warning',
        content: getErrorMsg('login'),
      }
      yield put({ type: String(addNotification), payload: loginErrorNotification })
    }
  }
}

export function* loginSagas() {
  yield all([takeEvery(String(doLogin), sagaPasswordAuth)])
}
